import { render, staticRenderFns } from "./SystemAdminLanding.vue?vue&type=template&id=c43be444&scoped=true"
import script from "./SystemAdminLanding.vue?vue&type=script&lang=ts"
export * from "./SystemAdminLanding.vue?vue&type=script&lang=ts"
import style0 from "./SystemAdminLanding.vue?vue&type=style&index=0&id=c43be444&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c43be444",
  null
  
)

export default component.exports